import { Directive, forwardRef, Input, OnChanges, SimpleChanges, Type } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { ProvincesStatesCodesService } from '../../services/provinces-states/provinces-states-codes.service';
import { PostalCodeService } from './postal-code.service';

/**
 * tdWbPostalCodeValidator
 * Raises error defined when postal code is incorrect for specific province
 */
@Directive({
  selector: '[tdWbPostalCodeValidator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: forwardRef((): Type<PostalCodeValidatorDirective> => PostalCodeValidatorDirective),
    multi: true
  }]

})
export class PostalCodeValidatorDirective implements Validator, OnChanges {
  @Input() tdWbPostalCodeValidator: string;

  private _onChange: (changes: SimpleChanges) => void;

  constructor(private provinceStatesCodesService: ProvincesStatesCodesService) {
  }

  validate(thisControl: AbstractControl): ValidationErrors | null {
    if (this.tdWbPostalCodeValidator !== undefined) {
      const dropdownSelection = this.tdWbPostalCodeValidator;
      const postalCode = thisControl.value;
      const provinces = this.provinceStatesCodesService.provinces.provinceCodes;
      let valid = false;
      if (dropdownSelection === this.provinceStatesCodesService.other.otherCountry) {
        valid = PostalCodeService.OTHER_POSTAL_CODE_REGEX.test(postalCode);
      } else if (Object.keys(provinces).map((province: string): unknown => provinces[province]).indexOf(dropdownSelection) > -1) {
        valid = PostalCodeService.CANADIAN_POSTAL_CODE_REGEX.test(postalCode);
      } else {
        valid = PostalCodeService.US_POSTAL_CODE_REGEX.test(postalCode);
      }
      return valid ? null : { invalidPostalCode: true };
    }
    return null;
  }

  registerOnValidatorChange(fn: (changes: SimpleChanges) => void): void {
    this._onChange = fn;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this._onChange !== undefined) {
      this._onChange(changes);
    }
  }
}
